export function lowercase (text) {
  return text ? String(text).toLowerCase() : '';
}
